exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".verify-account-shell-4Nryk4CZmwr{max-width:360px}.verify-account-logo-79BVz6Jgmwr{height:40px}\n", ""]);
// Exports
exports.locals = {
	"shell": "verify-account-shell-4Nryk4CZmwr",
	"logo": "verify-account-logo-79BVz6Jgmwr"
};